import { render, staticRenderFns } from "./HorizontalMetricBarGraph.vue?vue&type=template&id=566bb8d1&scoped=true"
import script from "./HorizontalMetricBarGraph.vue?vue&type=script&lang=js"
export * from "./HorizontalMetricBarGraph.vue?vue&type=script&lang=js"
import style0 from "./HorizontalMetricBarGraph.vue?vue&type=style&index=0&id=566bb8d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566bb8d1",
  null
  
)

export default component.exports